import RangePickerContainer from './containers/RangePickerContainer';

export default RangePickerContainer;
